import { Tooltip } from '@mantine/core'
import { ReactComponent as NonProRataIcon } from 'app/public/generic-icons/non-pro-rata-icon.svg'

interface NonProRataIconWithTooltipProps {
    size?: number
    tooltipText?: string
}

export function NonProRataIconWithTooltip({
    size = 24,
    tooltipText = 'This facility has loan(s) with Non-ProRata lender allocations'
}: NonProRataIconWithTooltipProps) {
    return (
        <Tooltip label={tooltipText} styles={{ tooltip: { fontSize: '12px', padding: '10px', letterSpacing: '1px' } }}>
            <div style={{ display: 'inline-flex', alignItems: 'center', lineHeight: 1 }}>
                <NonProRataIcon style={{ width: `${size}px`, height: `${size}px` }} />
            </div>
        </Tooltip>
    )
}
